"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _default = {
  CONNECTED: 'connected',
  AUTHORIZATION_EXPIRED: 'authorization_expired',
  NOT_AUTHORIZED: 'not_authorized',
  UNKNOWN: 'unknown'
};
exports["default"] = _default;